import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { layout } from '../../config/styles';
import { DND_BASE_LAYER_Z_INDEX } from '../DndEntity/constants';
import { theme } from '../../styles/theme';

interface IProps {
  isExpanded: boolean;
  width?: number;
}

const DEFAULT_WIDTH = 304;

const FixedWrapper = styled.div`
  height: 100%;
  padding-top: ${layout.headerHeight}px;
  background-color: ${theme.colors.level1};
  position: fixed;
  top: 0;
  right: 44px;
  border-left: 1px solid ${theme.colors.border};
  z-index: ${DND_BASE_LAYER_Z_INDEX + 4};
  transition: transform 0.3s ease-out;
  display: flex;
  flex-direction: column;
`;

const CollapsableSideBar = ({
  isExpanded,
  width = DEFAULT_WIDTH,
  children,
}: PropsWithChildren<IProps>) => {
  const containerWidth = isExpanded ? width : 0;

  return (
    <div
      style={{
        flex: `0 0 ${containerWidth}px`,
        width: containerWidth,
      }}
    >
      <FixedWrapper
        style={{
          width,
          transform: `translateX(${isExpanded ? 0 : '100%'})`,
        }}
      >
        {children}
      </FixedWrapper>
    </div>
  );
};

export default CollapsableSideBar;
